<template>
  <div class="casino-header-nt2">
    <div class="casino-header">
        <div class="active-provider">
            <div class="game">
              <h4 class="line-title">{{ currentProvider }}</h4>
            </div>
        </div>
        <button class="button primary" @click="toggle = !toggle" :class="{ active : toggle}">
          {{ toggle ? 'Kapat' : 'Sağlayıcılar'}}  
          <span>
            <svg x="0px" y="0px" viewBox="0 0 490 490" xml:space="preserve"><g><g><polygon points="490,157.332 244.996,407.369 0,157.332 76.493,82.631 244.996,254.598 413.507,82.631   "></polygon></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
          </span>
        </button>
    </div>
    <div :class="{ 'toggle-active' : toggle}">
      <Providers/>
    </div>
  </div>
</template>

<script>
    import Providers from './Providers'
    import SelectBox from '../Common/SelectBox'
    export default{
      data(){
        return{
          toggle: false,
        }
      },
      watch:{
        currentProvider(val){
          this.toggle = false;
        }
      },
      computed:{
        currentProvider(){
          return this.$store.getters['casino/getCurrentProvider'];
        }
      },
      components:{
        Providers,
        SelectBox
      }
    }
</script>